import React, { useEffect } from 'react'
import { compose } from 'recompose'
import withJsonApiProps from '../utils/withJsonApiProps'
import withLayout from '../utils/withLayout'
import ApplicationLayout from '../components/ApplicationLayout'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import StepForm from '../forms/StepForm'
import * as Yup from 'yup'
import { STEP } from 'config'
import { householdMember } from '../types'
import { Button } from 'lp-components'
import goToNextStep from '../utils/goToNextStep'

const propTypes = {
  householdMembers: PropTypes.arrayOf(householdMember),
}

function ConnectToTruv({ householdMembers }) {
  const truvIsDefined = () => typeof window.TruvBridge !== 'undefined'
  useEffect(() => {
    if (!truvIsDefined()) {
      // Insert the script if not inserted yet.
      const script = document.createElement('script')
      script.src = 'https://cdn.truv.com/bridge.js'
      document.querySelector('head').append(script)
    }
  }, [])

  const submitTruvIncome = () => {
    goToNextStep(STEP.PERSONAL_VERIFICATION)
  }

  const initBridgeFor = (member) => {
    const { truvOrderBridgeToken } = member
    const bridgeHelper = window.TruvBridge.init({
      bridgeToken: truvOrderBridgeToken,
      isOrder: true,
    })
    bridgeHelper.open()
  }

  const validationSchema = Yup.object({})
  const syncableMemberExist = householdMembers.length > 0
  return (
    <>
      <Helmet>
        <title>Verify Income</title>
      </Helmet>
      <div className="page-header">
        <h1>Verify Income</h1>
        {syncableMemberExist ? (
          <>
            <p>
              In this section, you can connect your payroll provider for
              login.gov to verify wages and other sources of income. All you
              need to do is login to your account, and all of the required
              information will be automatically added to your application.
            </p>
            <p>
              <b>Note: </b>&nbsp;This connection has an expiration of 72 hours
              (3 days). After that, if you don't complete it, you will need to
              refill the information. If you perform any changes to your
              incomes, you will also need to refill your information
            </p>
          </>
        ) : (
          <p>
            You don't have any household member that can sync their incomes.
            Please, continue to the next section
          </p>
        )}
      </div>
      <StepForm
        previousStep={STEP.CONTACT_INFORMATION}
        onSubmit={submitTruvIncome}
        initialValues={{}}
        validationSchema={validationSchema}
        nextStep={STEP.APPLICATION_INFORMATION}
      >
        {syncableMemberExist && (
          <div className="form-section">
            {householdMembers.map((member) => (
              <div className="row" key={member.sfid}>
                <div className="col-9">
                  <h3>{`${member.firstName} ${member.lastName}`}</h3>
                </div>
                <div className="col-3">
                  <Button
                    className="button-primary-outline"
                    onClick={() => initBridgeFor(member)}
                  >
                    Start verification
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </StepForm>
    </>
  )
}

ConnectToTruv.propTypes = propTypes

export default compose(
  withJsonApiProps(),
  withLayout(ApplicationLayout)
)(ConnectToTruv)
